import axios from '@/axios.js'
import { QuerySerialize } from '@/utils'
import { notifyServerError } from '@/layouts/notifies'

const flatten = data =>
  Object.keys(data).flatMap(category =>
    Object.keys(data[category]).flatMap(subject =>
      data[category][subject].length
        ? data[category][subject].map(item => ({ ...item, subject, category }))
        : []
    )
  )

export default {
  fetchRequests(context, payload = { skip: 0, limit: 0, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`requests/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchHealthRequests(context, payload = { skip: 0, limit: 0, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`requests/health/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          response.data = flatten(response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchHealthRequestById(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`requests/health/?_id=${id}`)
        .then(response => {
          response.data = flatten(response.data)[0]
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchRequestsByCategory(context, payload = { category: null, skip: 0, limit: 0, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`requests/health/${payload.category}/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  createRequestBySubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${payload.category}/${payload.subject}`, payload.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  countRequestBySubject(context, payload = { query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`${payload.category}/${payload.subject}/count/?${query}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchRequestsBySubject(context, payload = { skip: 0, limit: 0, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`${payload.category}/${payload.subject}/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchSuggestionBySubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${payload.category}/${payload.subject}/suggestion`, payload.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchRequestBySubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${payload.category}/${payload.subject}/${payload.id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchRequestDetailsBySubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${payload.category}/${payload.subject}/${payload.id}/details`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeRequestBySubject({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${payload.category}/${payload.subject}/${payload.id}`)
        .then(response => {
          commit('REMOVE_RECORD', payload.id)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  updateRequestBySubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${payload.category}/${payload.subject}/${payload.id}/${payload.activity}/`, payload.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editRequestBySubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${payload.category}/${payload.subject}/${payload.id}`, payload.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
